import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ListMonthlyStatementsChild from "./ListMonthlyStatementsChild";

const ListMonthlyStatements = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ListMonthlyStatementsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ListMonthlyStatements;
